import { getRefresh, setTokens } from "./auth";
import { API_BASE } from "./config";

let pendingRefresh = null;

async function performRefresh() {
  const refresh = getRefresh();
  if (!refresh || refresh === "null" || refresh === "undefined") throw new Error("No refresh token");
  const checkSession = () => {
    if (getRefresh() !== refresh) {
      const error = new Error("Session changed during refresh");
      error.code = "session_changed";
      throw error;
    }
  };
  try {
    const response = await fetch(`${API_BASE.replace(/\/$/, "")}/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });
    checkSession();
    if (!response.ok) throw new Error("Refresh failed");
    const data = await response.json();
    checkSession();
    if (!data.access) throw new Error("Refresh failed");
    const tokens = { access: data.access, refresh: data.refresh || refresh };
    setTokens(tokens);
    return tokens;
  } catch (error) {
    // A failed old request must not log out a newly signed-in account either.
    checkSession();
    throw error;
  }
}

// All Users-page requests share one rotation. Parallel requests must not reuse
// a refresh token after the server has blacklisted it.
export function refreshSession() {
  if (!pendingRefresh) {
    pendingRefresh = performRefresh().finally(() => { pendingRefresh = null; });
  }
  return pendingRefresh;
}
